"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Toolbar = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const blueprint_1 = require("@groma-dev/blueprint");
const Toolbar_module_scss_1 = __importDefault(require("./Toolbar.module.scss"));
/**
 * The Toolbar component is a container which center aligns its children vertically and applies space between styling to take up 100% of its width
 *
 * The `<Toolbar />` is intended to be used within the `<AppBar />` component.
 * @param props
 * @constructor
 */
const Toolbar = (props) => {
    const { children, testId, disableGutters = false, className } = props, args = __rest(props, ["children", "testId", "disableGutters", "className"]);
    const dti = (0, blueprint_1.getTestIdAttribute)(testId);
    return ((0, jsx_runtime_1.jsx)("div", Object.assign({}, args, { className: (0, blueprint_1.classNames)('Header-toolbar-local', className, Toolbar_module_scss_1.default.toolbar, disableGutters && Toolbar_module_scss_1.default.noGutter) }, dti, { children: children })));
};
exports.Toolbar = Toolbar;
